<template>
  <div class="bgeditNews">
    <el-dialog title="编辑文章" :visible.sync="showEditNews" width='800px' :close-on-click-modal='false'>
      <el-form label-width='100px'>
        <el-form-item label='文章标题'>
          <el-input v-model='forms.label' placeholder='请输入文章标题' size='medium' style='width:300px' />
        </el-form-item>
        <el-form-item label='文章封面图'>
          <div class="addimg">
            <div class="imgform" v-if='forms.img' @click='closeArticleImg'>
              <img :src="forms.img" alt="">
            </div>
            <div v-else>
              <el-button size='small' @click='addCover("article")'>添加图片</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label='文章分类'>
          <el-radio v-model='forms.classify' v-for='item in classify' :key='item.id' :label='item.id'>{{item.title}}</el-radio>
          <el-input size='small' ref='addinput' v-model='classValue' @keyup.enter.native='addClassifySubmit' @blur='addClassifySubmit'
            style='width:80px;margin-left: 20px' v-if='addinput' />
          <el-button size='small' @click='addclassify' style='margin-left: 20px' v-else>添加分类</el-button>
        </el-form-item>
        <el-form-item label='文章详情'>
          <div class="editbox">
            <VueUeditorWrap v-model='forms.content' />
          </div>
        </el-form-item>
        <div class="mbtns">
          <el-button size='medium' type='primary' @click='editArticleSuccess'>确定</el-button>
          <el-button size='medium' @click='showEditNews=false'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑商品分类" width='500px' :visible.sync="showEditGoodsClassify" :show-close='false' :close-on-click-modal='false'>
      <el-form label-width='80px'>
        <el-form-item label='分类图片'>
          <div class="classifyimg" v-if="goodsClassifyForm.img_url">
            <img :src="goodsClassifyForm.img_url" alt="">
            <div class="clearImgTr" @click='goodsClassifyForm.img_url=""'>
              <svg-icon icon-class='del' />
            </div>
          </div>
          <div class="addclassifyimg" @click='selectgoodsClassifyImg' v-else>
            <svg-icon icon-class='add' />
          </div>
        </el-form-item>
        <el-form-item label='分类标题'>
          <el-input v-model='goodsClassifyForm.title' placeholder='请输入分类标题' size='medium' style='width:300px' />
        </el-form-item>
        <el-form-item label='添加至'>
          <el-select :disabled='goodsClassifyForm.classify_id? true:false' v-model="goodsClassifyForm.parent_id" style='width:300px'
            placeholder="请选择">
            <el-option v-for="item in goodsClassifyStore" v-if='item.parent_id==0' :key="item.id" :label="item.title" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <div class="mbtns">
          <el-button size='medium' type='primary' @click='editGoodsClassifySuccess'>确定</el-button>
          <el-button size='medium' @click='$store.commit("hideeditGoodsClassify",false)'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑商品" :visible.sync="showGoods" :close-on-click-modal='false' width='1000px'>
      <el-form label-width='100px' class='addGoodsDialog'>
        <el-form-item label='商品标题'>
          <el-input v-model='goodsForms.title' placeholder='请输入商品标题' size='small' style='width:300px' :fetch-suggestions='getSuggestions' />
        </el-form-item>
        <el-form-item label='简介'>
          <el-input v-model='goodsForms.introduction' type='textarea' placeholder='请输入商品简介' size='small' style='width:500px' />
        </el-form-item>
        <el-form-item label='商品主图'>
          <div class="addimg">
            <div v-if='goodsForms.images.length>0' class="goodlist">
              <div class="imgform" v-for='(goods,gi) in goodsForms.images' :key='gi' @click='goodsForms.images.splice(gi,1)'>
                <img :src="goods" alt="">
              </div>
            </div>
            <div v-if='goodsForms.images.length<5' class='addbtn'>
              <el-button size='small' @click='addCover("goods")'>添加图片</el-button>
              <span style="color: #aaa">预览图默认获取第一张图</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label='商品分类'>
          <el-cascader expand-trigger="hover" :props='{value:"id",label:"title"}' :options="goodsClassify" @change='changeCascader'
            v-model="classcascader"></el-cascader>
          <el-input size='small' ref='addinput' v-model='classValue' @keyup.enter.native='addClassifySubmit("goods")'
            @blur='addClassifySubmit("goods")' style='width:80px;margin-left: 20px' v-if='addinput' />
          <el-button size='small' @click='addclassify' style='margin-left: 20px' v-else>添加分类</el-button>
        </el-form-item>
        <el-form-item label='商品规格'>
          <div class="guige">
            <div class="ggline" v-for='(option,oi) in goodsForms.g_options' :key='oi'>
              <div class="option_title">
                <el-input size='small' @blur='inputBlur($event)' placeholder='规格名' :id='`g_o_title_${oi}`' v-model='option.g_o_title'
                  style='width: 130px' />
                <div class="icoclose" @click='delRow(oi)'>
                  <svg-icon class='ico' icon-class='close' />
                </div>
              </div>
              <div class="option_value">
                <el-input size='small' @blur='inputBlur($event,option.g_o_value,vi)' placeholder='规格值' v-for='(vals,vi) in option.g_o_value'
                  :id='`g_o_value_${oi}_${vi}`' clearable @clear='delChild(option,vi)' :key='vi' v-model='option.g_o_value[vi]'
                  style='width: 130px;margin-right: 10px;' />
                <el-button size='mini' @click='addGgChild(option,`g_o_value_${oi}_${option.g_o_value.length}`)' type='text'>添加规格值</el-button>
              </div>
            </div>
            <div class="ggline">
              <div class="option_title">
                <el-button size='mini' @click='addGg' v-if='goodsForms.g_options.length<3'>添加规格项目</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label='规格明细' v-if='goodsForms.g_options[0] && goodsForms.g_options[0].g_o_title'>
          <div class="g_table">
            <div class="g_table_chid">
              <div class="g_table_0" v-for='(th,ti) in goodsForms.g_options' style="width: 100px;" :key='ti'>{{th.g_o_title || "未命名"}}</div>
              <div class="g_table_0">价格</div>
              <div class="g_table_0">库存</div>
            </div>
            <div class="g_table_chid" v-for="(v0,i0) in goodsForms.g_options[0].g_o_value" v-if='goodsForms.g_options[0]' :key='i0'>
              <div class="g_table_0" :title='v0'>{{ v0 }}</div>
              <template v-for='(inp,ini) in goodsForms.table' v-if='goodsForms.g_options[0] && !goodsForms.g_options[1]  && inp.attr_key == v0'>
                <div class="g_table_0" style="border-left: 1px solid #eee">
                  <el-input ref='gpinput' @blur='inputBlur($event)' v-model='inp.price' style='width: 80px' size='mini' />
                </div>
                <div class="g_table_0" style="border-left: 1px solid #eee">
                  <el-input ref='gginput' @blur='inputBlur($event)' v-model='inp.stock' style='width: 80px' size='mini' />
                </div>
              </template>

              <div class="secbox" v-if='goodsForms.g_options[1]'>
                <div class="g_table_1_f" v-for='(v1,i1) in goodsForms.g_options[1].g_o_value'>
                  <div class="g_table_1 g_table_1_title" :title='v1'>{{ v1 }}</div>
                  <template v-if='goodsForms.g_options[1] && !goodsForms.g_options[2] &&inp.attr_key == v0+"|"+v1'
                    v-for='(inp,ini) in goodsForms.table'>
                    <div class="g_table_1 g_table_price">
                      <el-input ref='gpinput' @blur='inputBlur($event)' v-model='inp.price' style='width: 80px' size='mini' />
                    </div>
                    <div class="g_table_1 g_table_price">
                      <el-input ref='gginput' @blur='inputBlur($event)' v-model='inp.stock' style='width: 80px' size='mini' />
                    </div>
                  </template>
                  <div class="thrbox" v-if='goodsForms.g_options[2]'>
                    <div class="g_table_2_f" v-for='(v2,i2) in goodsForms.g_options[2].g_o_value'>
                      <div class="g_table_2">{{v2}}</div>
                      <template v-if='inp.attr_key == v0+"|"+v1+"|"+v2' v-for='(inp,ini) in goodsForms.table'>
                        <div class="g_table_price g_table_2">
                          <el-input ref='gpinput' @blur='inputBlur($event)' v-model='inp.price' style='width: 80px' size='mini' />
                        </div>
                        <div class="g_table_price g_table_2">
                          <el-input ref='gginput' @blur='inputBlur($event)' v-model='inp.stock' style='width: 80px' size='mini' />
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="g_table_chid">
              <div class="g_table_0">批量修改</div>
              <el-popover placement="top" width="180" v-model="dialog1">
                <el-input v-model='priceAll' size='small' style='margin-bottom: 10px' @keyup.enter.native='editGoodsAll("price")' />
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="dialog1 = false">取消</el-button>
                  <el-button type="primary" size="mini" @click='editGoodsAll("price")'>确定</el-button>
                </div>
                <el-button size='mini' slot="reference" type='primary' style='margin-right: 10px'>修改价格</el-button>
              </el-popover>
              <el-popover placement="top" width="180" v-model="dialog2">
                <el-input v-model='savedAll' size='small' style='margin-bottom: 10px' @keyup.enter.native='editGoodsAll("saved")' />
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="dialog2 = false">取消</el-button>
                  <el-button type="primary" size="mini" @click='editGoodsAll("saved")'>确定</el-button>
                </div>
                <el-button size='mini' slot="reference">修改库存</el-button>
              </el-popover>
            </div>
          </div>
        </el-form-item>
        <el-form-item label='原价/元'>
          <el-input v-model='goodsForms.price' :disabled='goodsForms.g_options.length>0' placeholder='请输入商品价格' size='small' style='width:200px'>
          </el-input>
        </el-form-item>
        <el-form-item label='价格/元'>
          <el-input v-model='goodsForms.promotional_price' placeholder='请输入商品价格' :disabled='goodsForms.g_options.length>0' size='small'
            style='width:200px'></el-input>
        </el-form-item>
        <el-form-item label='库存'>
          <el-input v-model='goodsForms.stock' type='text' :disabled='goodsForms.g_options.length>0' size='small' style='width:200px'>
          </el-input>
        </el-form-item>
        <el-form-item label="重量">
          <el-input v-model="goodsForms.weight" type="number">
            <template slot="append">
              千克
            </template>
          </el-input>
          <br><span style="font-size: 13px;color: rgb(191, 19, 19)">用于快递或配送运费计重</span>
        </el-form-item>
        <el-form-item label="运费设置">
          <el-radio v-model='goodsForms.express_type' label='0'>统一系统运费</el-radio>
          <el-radio v-model='goodsForms.express_type' label='1'>使用运费模板</el-radio>
        </el-form-item>
        <el-form-item label='运费模板' v-if='goodsForms.express_type==1'>
          <el-select v-model="goodsForms.express_template_id" clearable filterable placeholder="请选择运费模板">
            <el-option label="请选择运费模板" value="0" />
            <el-option v-for="item in express_list" :key="item.id" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item  label='排序'>
        	<el-input  v-model='goodsForms.order_by' type='text' :disabled='goodsForms.g_options.length>0' size='small' style='width:200px'>
        	</el-input>
        </el-form-item> -->

        <el-form-item label='虚拟订单数'>
          <el-input v-model='goodsForms.virtual' placeholder='' size='small' style='width:200px'></el-input>
        </el-form-item>
        <el-form-item label='服务说明'>
          <el-checkbox v-model='goodsForms.sever_7dback'>七天无理由退换货</el-checkbox>
          <el-checkbox v-model='goodsForms.sever_in24'>承诺24小时内发货</el-checkbox>
          <el-checkbox v-model='goodsForms.sever_in72'>承诺72小时内发货</el-checkbox>
          <el-checkbox v-model='goodsForms.sever_ins'>赠运费险</el-checkbox>
          <el-checkbox v-model='goodsForms.sever_quality'>正品保证</el-checkbox>
        </el-form-item>
        <el-form-item label='积分赠送'>
          <el-input v-model='goodsForms.gift_integral' placeholder='' size='small' style='width:200px'>
            <template slot="append">分</template>
          </el-input>
          <el-popover placement="right" width="400" trigger="hover">
            <div>
              会员购物赠送的积分, 如果不填写或填写0，则默认为不赠送积分，如果带%则为按成交价格的比例计算积分 <br><br>
              如: 购买2件，设置10 积分, 不管成交价格是多少， 则购买后获得20积分 <br><br>
              如: 购买2件，设置10%积分, 成交价格2 * 200= 400， 则购买后获得 40 积分（400*10%）<br><br>
              默认100积分抵扣1元，您可以在商城营销->积分修改
            </div>
            <svg-icon slot="reference" style='width: 20px;height: 20px;color:#999' icon-class='question' />
          </el-popover>

        </el-form-item>
        <el-form-item label='积分抵扣'>
          <el-input v-model='goodsForms.deduction_integral' placeholder='' size='small' style='width:200px'>
            <template slot="append">分</template>
          </el-input>
          <el-popover placement="right" width="400" trigger="hover">
            <div>
              如果设置0，则不支持积分抵扣 如果带%则为按成交价格的比例计算抵扣多少元
            </div>
            <svg-icon slot="reference" style='width: 20px;height: 20px;color:#999' icon-class='question' />
          </el-popover>
        </el-form-item>
        <el-form-item label='限购(件)'>
          <el-input placeholder="数量" v-model="goodsForms.limit_num" class="input-with-select" style='width: 200px'>
            <el-select v-model="goodsForms.limit_type" slot="prepend" placeholder="不限购" style='width: 110px'>
              <el-option label="不限购" value="0"></el-option>
              <el-option label="每日限购" value="1"></el-option>
              <el-option label="每周限购" value="2"></el-option>
              <el-option label="每月限购" value="3"></el-option>
              <el-option label="永久限购" value="4"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label='商品详情'>
          <VueUeditorWrap v-model='goodsForms.details' />
        </el-form-item>
        <div class="mbtns">
          <el-button size='medium' type='primary' @click='editGoodsSuccess'>确定</el-button>
          <el-button size='medium' @click='showGoods=false'>取消</el-button>
          <!-- <el-button size='medium' @click='get_taobao_goods'>采集淘宝商品</el-button> -->
          <a v-if='goodsForms.tburl' style="margin-left: 20px" target="blank" :href="goodsForms.tburl">
            <el-button type='text' size='medium'>查看源商品</el-button>
          </a>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑服务" :visible.sync="showEditSever" width='800px' :close-on-click-modal='false'>
      <el-form label-width='200'>
        <el-form-item label-width='100px' label='名称'>
          <el-input v-model='severForm.title' placeholder='请输入服务标题' size='medium' style='width:500px' />
        </el-form-item>
        <el-form-item label-width='100px' label='摘要'>
          <el-input v-model='severForm.summary' type='textarea' placeholder='请输入服务摘要' size='medium' style='width:500px' />
        </el-form-item>
        <el-form-item label-width='100px' label='主图'>
          <div class="">
            <div v-if='this.severForm.cover_url.length<4'>
              <el-button size='small' @click='addSeverCover'>添加图片</el-button>
              <span style="margin-left: 10px;color: #aaa">默认获取第一张图</span>
            </div>
            <div class="imgform" @click='spliceImg(severForm.cover_url,imgi)' v-for='(img,imgi) in severForm.cover_url' :key='imgi'>
              <img :src="img" alt="">
            </div>
          </div>
        </el-form-item>
        <el-form-item label-width='100px' label='服务分类'>
          <el-radio v-model='severForm.cid' v-for='(item) in severClassify' :key='item.id' :label='item.id'>{{item.title}}</el-radio>
          <el-input size='small' ref='addinput' v-model='classValue' @keyup.enter.native='addClassifySubmit("sever")'
            @blur='addClassifySubmit("sever")' style='width:80px;margin-left: 20px' v-if='addinput' />
          <el-button size='small' @click='addclassify' style='margin-left: 20px' v-else>添加分类</el-button>
        </el-form-item>
        <el-form-item label-width='100px' label='价格类型'>
          <el-radio v-model='severForm.price_type' label='0'>默认</el-radio>
          <el-radio v-model='severForm.price_type' label='1'>免费</el-radio>
          <el-radio v-model='severForm.price_type' label='2'>面议</el-radio>
        </el-form-item>
        <div v-if='severForm.price_type==0'>
          <el-form-item label-width='100px' label='原价/元'>
            <el-input v-model='severForm.price' placeholder='请输入服务标题' size='medium' style='width:200px' />
          </el-form-item>
          <el-form-item label-width='100px' label='价格/元'>
            <el-input v-model='severForm.sale_price' placeholder='请输入服务标题' size='medium' style='width:200px' />
          </el-form-item>
        </div>
        <el-form-item label-width='100px' label='需要预留日期'>
          <el-radio v-model='severForm.need_date' label='0'>否</el-radio>
          <el-radio v-model='severForm.need_date' label='1'>是</el-radio>
        </el-form-item>
        <el-form-item label-width='100px' label='多选日期'>
          <el-radio v-model='severForm.date_select' label='0'>否</el-radio>
          <el-radio v-model='severForm.date_select' label='1'>是</el-radio>
        </el-form-item>
        <el-form-item label-width='100px' :label='severForm.need_date==1?"每日限量":"限量"'>
          <el-radio v-model='severForm.limited' label='0'>否</el-radio>
          <el-radio v-model='severForm.limited' label='1'>是</el-radio>
        </el-form-item>
        <el-form-item label-width='100px' v-if='severForm.limited==1'>
          <el-input v-model='severForm.limited_num' type='text' size='medium' style='width:200px' />
        </el-form-item>
        <el-form-item label-width='100px' label='虚拟订单数'>
          <el-input v-model='severForm.false_sales' placeholder='请输入虚拟订单数' size='medium' style='width:200px' />
        </el-form-item>
        <el-form-item label-width='100px' label='服务详情'>
          <div class="editbox">
            <VueUeditorWrap v-model='severForm.details' />
          </div>
        </el-form-item>
        <div class="mbtns">
          <el-button size='medium' type='primary' @click='editSeverSuccess'>确定</el-button>
          <el-button size='medium' @click='showEditSever=false'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="编辑名片" :visible.sync="showEditCard">
      <el-form label-width='200'>
        <el-form-item label-width='60px' label='姓名'>
          <el-input v-model='cardForm.name' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='手机'>
          <el-input v-model='cardForm.telphone' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='岗位'>
          <el-input v-model='cardForm.post' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='邮箱'>
          <el-input v-model='cardForm.email' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='微信'>
          <el-input v-model='cardForm.wechat' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='地址'>
          <el-input v-model='cardForm.address' size='medium' style='width:400px' />
        </el-form-item>
        <el-form-item label-width='60px' label='头像'>
          <div class="">
            <div class="imgform" @click='cardForm.avatar=""' v-if='cardForm.avatar'>
              <img :src="cardForm.avatar" alt="">
            </div>
            <div v-else>
              <el-button size='small' @click='addCover("card")'>添加图片</el-button>
              <span style="margin-left: 10px;color: #aaa">最佳尺寸：750*750px</span>
            </div>
          </div>
        </el-form-item>
        <div class="editbox">
          <VueUeditorWrap v-model='cardForm.introduction' />
        </div>
        <div class="mbtns">
          <el-button size='medium' type='primary' @click='editCardSuccess'>确定</el-button>
          <el-button size='medium' @click='showEditCard=false'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="选择图标" :visible.sync="showSelectIco" width='940px'>
      <el-form label-width='200'>
        <div class="selectIcobox">
          <div class="left">
            <div @click='usericoNav="图标"' class="li" :style="usericoNav=='图标'? 'border-color: #557ce1' :''">图标库</div>
            <div @click='usericoNav="图片"' class="li" :style="usericoNav=='图片'? 'border-color: #557ce1' :''">图片</div>
          </div>
          <div class="icobox" v-if="usericoNav=='图标'">
            <div class="li" :class='item.check?"on":""' :key='index' v-for='(item,index) in usericos' @click='checkSection(item,"once",usericos)'>
              <svg-icon class='ico' :icon-class='item.icon' />
            </div>
          </div>
          <div v-if="usericoNav=='图片'" class="imgbox">
            <div v-if='usericoImg' class="icosss">
              <img style="width: 100%;min-height: 50px" :src="usericoImg" alt="">
            </div>
            <div class="selimg">
              <el-button size='small' style='width: 80px' @click='addCover("ico")'>选择图标</el-button>
              <span style='font-size: 12px;color: #999;'>使用图片图标将无法使用全局颜色</span>
            </div>
          </div>

        </div>
        <div class="mbtns">
          <el-button size='medium' @click='editIcoSuccess' type='primary'>确定</el-button>
          <el-button size='medium' @click='showSelectIco=false'>取消</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog title="链接地址" width='700px' :visible.sync="showSelectUrl">
      <el-form label-width='200' style='min-height: 300px' @submit.native.prevent>
        <el-form-item label='链接类型'>
          <el-radio v-model='selectFirst' v-for='(item,index) in urlList' @change='resetUrl' :key='index' :label='item.value'>{{item.label}}
          </el-radio>
        </el-form-item>
        <el-form-item label='选择页面' v-if='selectFirst=="slef://"' style='width: 300px' size='small'>
          <el-select v-model="selectLast" placeholder="请选择链接页面">
            <el-option v-for="(item,index) in appPage" :key="index" :label="item.title" :value="item.url">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='输入电话' v-if='selectFirst=="tel://"'>
          <el-input v-model="selectLast" placeholder="请输入电话号码" style='width: 199px' size='small' />
        </el-form-item>
        <el-form-item label='服务页面' v-if='selectFirst=="sever://"'>
          <el-select v-model="selectLast" placeholder="请选择链接页面">
            <el-option v-for="(item,index) in severList" :key="index" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='文章页面' v-if='selectFirst=="news://"'>
          <el-select v-model="selectLast" placeholder="请选择链接页面">
            <el-option v-if='item.is_hidden==0' v-for="(item,index) in articleList" :key="index" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='商品' v-if='selectFirst=="goods://"'>
          <el-select v-model="selectLast" placeholder="请选择链接页面">
            <el-option v-for="(item,index) in goodslist" :key="index" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='商品分类' v-if='selectFirst=="goodsclassify://"'>
          <!-- 	<el-select v-model="selectLast" placeholder="请选择链接页面">
						<el-option v-for="(item,index) in goodsClassify" :key="index" :label="item.title" :value="item.id">
						</el-option>
					</el-select> -->
          <el-cascader v-model="selectLast" :options="goodsClassify" :props='{checkStrictly: true,value:"id",label:"title"}' clearable></el-cascader>

        </el-form-item>
        <el-form-item label='Appid' v-if='selectFirst=="minapp://"'>
          <el-input v-model="selectLast" placeholder="请输入小程序APPID" style='width: 199px' size='small' />
        </el-form-item>
        <div class="mapBox" v-if='selectFirst=="map://"'>
          <el-form-item label='详细位置'>
            <el-input size='small' placeholder='请输入详细地址' v-model='inputAddr' style='width: 400px' @keyup.enter.native='searchMap' />
            <el-button size='small' @click='searchMap'>目标位置</el-button>
          </el-form-item>
          <div id="tMap" style="width: 100%;height: 300px;"></div>
        </div>
      </el-form>
      <div class="mbtns">
        <el-button size='medium' @click='selectUrlSuccess' type='primary'>确定</el-button>
        <el-button size='medium' @click='showSelectUrl=false'>取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑优惠券" append-to-body :visible.sync="showEditCoupon" width="700px">
      <el-form label-position="right" label-width="90px" :model="coupon_forms">
        <el-form-item label="优惠券名">
          <el-input size='small' v-model="coupon_forms.title" placeholder='输入优惠券名称'></el-input>
        </el-form-item>
        <el-form-item label="使用门槛">
          <span>满</span>
          <el-input v-model='coupon_forms.full' style='width: 100px;' size='small'></el-input>
          <span>减</span>
          <el-input v-model='coupon_forms.reduction' style='width: 100px;' size='small'></el-input>
        </el-form-item>
        <el-form-item label="使用规则">
          <el-radio v-model='coupon_forms.use_rule' label='0'>全部可用</el-radio>
          <el-radio v-model='coupon_forms.use_rule' label='1'>指定分类可用</el-radio>
          <el-radio v-model='coupon_forms.use_rule' label='2'>指定商品可用</el-radio>
          <el-radio v-model='coupon_forms.use_rule' label='3'>指定课程可用</el-radio>
        </el-form-item>
        <el-form-item label="可用分类" v-if='coupon_forms.use_rule==1'>
          <el-transfer filterable filter-placeholder="搜索分类" :props="{key:'id',label:'title'}" v-model="coupon_forms.value" :data="goodsClassify">
          </el-transfer>
        </el-form-item>
        <el-form-item label="可用商品" v-if='coupon_forms.use_rule==2'>
          <el-transfer filterable filter-placeholder="搜索商品" :props="{key:'id',label:'title'}" v-model="coupon_forms.value" :data="goodslist">
          </el-transfer>
        </el-form-item>
        <el-form-item label="可用课程" v-if='coupon_forms.use_rule==3'>
          <el-transfer filterable filter-placeholder="搜索课程" :props="{key:'id',label:'title'}" v-model="coupon_forms.value" :data="course_list">
          </el-transfer>
        </el-form-item>
        <el-form-item label="有效期类型">
          <el-radio v-model='coupon_forms.type' label='0'>领券后有效期内可用</el-radio>
          <el-radio v-model='coupon_forms.type' label='1'>固定有效期范围内可用</el-radio>
        </el-form-item>
        <el-form-item label="有效期(天)" v-if='coupon_forms.type==0'>
          <el-input v-model='coupon_forms.expiry' size='small'></el-input>
        </el-form-item>
        <el-form-item label="有效期" v-if='coupon_forms.type==1'>
          <el-date-picker size='small' value-format='yyyy-MM-dd HH:mm:ss' v-model="coupon_forms.date" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="每人限量数">
          <el-input v-model='coupon_forms.user_limit' size='small'></el-input>
        </el-form-item>
        <el-form-item label="总限量">
          <el-input size='small' v-model='coupon_forms.total_num'></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditCoupon = false">取消</el-button>
        <el-button type="primary" v-loading.fullscreen.lock="loadings" @click="save_coupon">保存</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import VueUeditorWrap from 'vue-ueditor-wrap'
import { test, get_classify_list, add_classify, addArticle, editArticle, getArticleOnce, get_sever_classify_list, add_sever_classify, addSever, editSever, getSeverList, addCard, editCard, delCard, getClassifyList, addGoodsClassify, addGoods, editGoods, get_taobao_goods, addTicket, editTicket, getGoodsList, get_course_list, getArticleList } from "@/api/api"

var _this, watchTable;
let severForm = {
  title: '',
  summary: '',
  cover_url: [],
  price_type: "0",
  price: '',
  sale_price: '',
  false_sales: '',
  details: '',
  limited: "0",
  limited_num: '0',
  cid: '',
  need_date: '0',
  date_select: '0',
}
var geocoder, map, marker = null;
export default {
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      img_group_now: 0,
      img_group: [],
      addinput: false,
      showEditNews: false,
      showEditSever: false,
      showEditCard: false,
      showSelectIco: false,
      showSelectUrl: false,
      showEditForm: true,
      showGoods: false,
      showEditCoupon: false,
      classValue: '',
      loadings: false,
      urlList: [
        { value: '', label: '无' },
        { value: 'slef://', label: '页面' },
        { value: 'tel://', label: '电话' },
        { value: 'sever://', label: '服务' },
        { value: 'news://', label: '文章' },
        { value: 'goodsclassify://', label: '商品分类' },
        { value: 'goods://', label: '商品' },
        { value: 'share://', label: '分享' },
        { value: 'map://', label: '地图' },
        {value:'minapp://',label:'外部小程序'},
      ],
      express_list: [],
      coupon_forms: {
        title: '',
        full: '',
        reduction: '',
        date: ["", ''],
        type: '0',
        expiry: '',
        use_rule: "0",
        total_num: '',

      },
      page_img: 1,
      appPage: [],
      selectFirst: '',
      selectLast: '',
      forms: {
        label: '',
        classify: '',
        content: '',
        img: '',
      },
      severForm,
      cardForm: {
        name: '',
        telphone: '',
        post: '',
        email: '',
        wechat: '',
        address: '',
        avatar: '',
        introduction: ''
      },
      dialog1: false,
      dialog2: false,
      savedAll: "",
      priceAll: "",
      goodsClassify: [],
      goodsForms: {
        title: '',
        images: [],
        introduction: '',
        cid: "",
        price: '',
        promotional_price: '',
        stock: '',
        virtual: '',
        details: '',
        sever_7dback: false,
        sever_in24: false,
        sever_in72: false,
        sever_ins: false,
        sever_quality: false,
        deduction_integral: "0",
        gift_integral: "0",
        g_options: [
        ],
        table: []
      },
      classcascader: [],
      usericoNav: '图标',
      usericoImg: '',
      usericos: [
        { icon: 'g_default' },
        { icon: 'g_default_on' },
        { icon: 'g_home' },
        { icon: 'g_home_on' },
        { icon: 'g_map' },
        { icon: 'g_map_on' },
        { icon: 'g_cart' },
        { icon: 'g_cart_on' },
        { icon: 'g_my' },
        { icon: 'g_my_on' },
      ],
      pagesize: 15,
      siteUrl: '',
      articleList: [],
      severList: [],
      classify: [],
      severClassify: [],
      inputAddr: '',
      lat: 39.916527,
      lng: 116.397128,
      goodslist: [],
      course_list: []
    }
  },
  mounted() {
    _this = this;
    // _this.initGoods()
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    showEditGoodsClassify() {
      return this.$store.state.showEditGoodsClassify
    },
    goodsClassifyStore() {
      return this.$store.state.goodsClassifyStore
    },
    goodsClassifyForm() {
      return this.$store.state.goodsClassifyForm
    }
  },
  watch: {
    'goodsForms.g_options': {
      handler(val, oldval) {
        if (watchTable) return;
        var table = JSON.parse(JSON.stringify(this.goodsForms.table));
        console.log(table)
        var newArray = [];
        if (val[2]) {
          val[0].g_o_value.forEach((v0, i0) => {
            val[1].g_o_value.forEach((v1, i1) => {
              val[2].g_o_value.forEach((v2, i2) => {
                newArray.push({ attr_key: `${v0}|${v1}|${v2}`, price: "", stock: "", goods_img: "" })
              })
            })
          })
        }
        else if (val[1]) {
          val[0].g_o_value.forEach((v0, i0) => {
            val[1].g_o_value.forEach((v1, i1) => {
              let old = table.find(old => {
                return old.attr_key == `${v0}|${v1}`
              })
              if (old) {
                newArray.push(old)
              } else {

                newArray.push({ attr_key: `${v0}|${v1}`, price: "", stock: "", goods_img: "" })
              }
            })
          })

        }
        else if (val[0]) {
          val[0].g_o_value.forEach((v0, i0) => {
            let old = table.find(old => {
              return old.attr_key == `${v0}`
            })
            console.log(old)
            newArray.push({ attr_key: `${v0}`, price: "", stock: "", goods_img: "" })
          })
        }
        console.log(newArray)
        this.goodsForms.table = newArray
        console.log("newarray", newArray)
      },
      deep: true
    }
  },
  methods: {
    play_video(item) {
      window.open(item.url)
      console.log(item)
    },
    editCoupon(action) {
      this.showEditCoupon = true;
      this.getgoodslist();
      this.get_course_list();
      this.getClassifyList();
      if (action == "add") {
        this.coupon_forms = {
          title: '',
          full: '',
          reduction: '',
          date: ['', ''],
          type: '0',
          expiry: '',
          total_num: '',
          use_rule: "0",
          is_limit_per: false,
          limit_per: "",
        }
      } else {
        action.date = [action.start_time, action.end_time];
        this.coupon_forms = action;
      }
    },
    getgoodslist() {
      getGoodsList({ pagesize: 1000 }, this, res => {
        this.goodslist = res.data.list
      })
    },
    get_course_list() {
      get_course_list({ pagesize: 1000 }, this, res => {
        this.course_list = res.data.list
      })
    },
    save_coupon() {
      var data = JSON.parse(JSON.stringify(this.coupon_forms));
      if (data.type == 1) {
        data.start_time = data.date[0];
        data.end_time = data.date[1];
      }
      if (data.id) {
        editTicket(data, this, res => {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.showEditCoupon = false;
        })
      }
      else {
        addTicket(data, this, res => {
          this.$message({
            type: 'success',
            message: res.data.msg
          })
          this.showEditCoupon = false;
        })
      }
    },
    get_taobao_goods() {
      console.log(this.goodsForms)

      this.$prompt('请输入淘宝商品地址链接', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        console.log(value)
        test({
          url: 'https://diytaobao.applinzi.com/taobao.php?url=' + value,
          data: {},
          ajaxfn: res => {
            if (res.data.ret[0] == "SUCCESS::调用成功") {
              console.log(res.data.data);
              let item = res.data.data.item;
              let values = JSON.parse(res.data.data.apiStack[0].value);
              let g_options = [];
              if (values.skuBase && values.skuBase.props && values.skuBase.props.length > 0) {
                values.skuBase.props.forEach((val, index) => {
                  val.g_o_title = val.name;
                  val.g_o_value = [];
                  val.values.forEach(val1 => {
                    val.g_o_value.push(val1.name);
                  })
                })
                if (values.skuBase.props.length > 3) {
                  values.skuBase.props.splice(2, values.skuBase.props.length - 3)
                }
                g_options = values.skuBase.props;
                if (g_options.length > 3) {
                  g_options.splice(3)
                }
              }
              let data = {
                title: item.title,
                images: item.images,
                introduction: item.subtitle,
                price: values.price.price.priceText,
                promotional_price: '',
                stock: 999,
                g_options,
                tburl: value,
                table: []
              }
              Object.assign(this.goodsForms, data);
            }
            else {
              this.$message("获取商品失败")
            }
          }
        })
        /*
        get_taobao_goods({url:value},this,res=>{
          if(res.data.ret[0]=="SUCCESS::调用成功"){
            console.log(res.data.data);
            let item = res.data.data.item;
            let values = JSON.parse(res.data.data.apiStack[0].value);
            let g_options=[];
            if(values.skuBase && values.skuBase.props && values.skuBase.props.length>0){
              values.skuBase.props.forEach((val,index)=>{
                val.g_o_title = val.name;
                val.g_o_value = [];
                val.values.forEach(val1=>{
                  val.g_o_value.push(val1.name);
                })
              })
              if(values.skuBase.props.length>3){
                values.skuBase.props.splice(2,values.skuBase.props.length-3)
              }
              g_options = values.skuBase.props;
              if(g_options.length>3){
                g_options.splice(3)
              }
            }
            let data = {
              title:item.title,
              images:item.images,
              introduction:item.subtitle,
              price:values.price.price.priceText,
              promotional_price:'',
              stock:999,
              g_options,
              tburl:value,
              table:[]
            }
            Object.assign(this.goodsForms,data);
          }
          else{
            this.$message("获取商品失败")
          }
        })*/
      }).catch();
    },
    changeCascader(e) {
      if (this.classcascader[1]) {
        let cid = this.classcascader.join(',');
        this.goodsForms.cid = cid.split("c")[0]
      }
    },
    selectgoodsClassifyImg() {
      this.$store.commit("select_img", {
        mult: 1,
        success: res => {
          this.goodsClassifyForm.img_url = res[0] ? res[0] : ""
        }
      })
    },
    editGoodsClassifySuccess(type) {
      this.$store.commit("editGoodsClassifySuccess")
    },
    getSuggestions(query, fn) {
      var suggestions = [
        { value: '颜色' },
        { value: '尺码' },
        { value: '尺寸' },
        { value: '衣领' },
        { value: '颜色' }
      ]
      fn(suggestions)
    },
    inputBlur(e, item, index) {
      if (e.target.value == "") {
        // this.$message({
        // 	type:'info',
        // 	message:'请输入规格名'
        // })
        e.target.style.border = '1px solid red'
        // e.target.focus()
      }
      else {
        e.target.style.border = ''
      }
      console.log(e)
    },
    initGoods() {
      this.goodsForms.g_table = table;
    },
    editGoodsAll(where) {
      if (where == "price") {
        this.goodsForms.table.forEach(val => {
          val.price = this.priceAll;
        })
        this.priceAll = "";
        this.dialog1 = false;
      }
      if (where == "saved") {
        this.goodsForms.table.forEach(val => {
          val.stock = this.savedAll;
        })
        this.savedAll = "";
        this.dialog2 = false;
      }
    },
    delRow(index) {
      this.goodsForms.g_options.splice(index, 1)
    },
    addGg() {
      this.goodsForms.g_options.push({ g_o_title: '', g_o_value: [""] });
      setTimeout(() => {
        let oid = 'g_o_title_' + (this.goodsForms.g_options.length - 1);
        let lastInput = document.getElementById(oid);
        lastInput.focus()
      }, 20)
    },
    addGgChild(item, willId) {
      console.log(willId);
      item.g_o_value.push("");
      setTimeout(() => {
        let lastInput = document.getElementById(willId);
        lastInput.focus()
      }, 20)
    },
    delChild(item, i) {
      if (item.g_o_value.length == 1) {
        this.$message({
          tpye: 'info',
          message: '可选规格不能低于1个'
        })
        return false;
      }
      item.g_o_value.splice(i, 1)
    },
    initMap() {
      this.TMap().then(qq => {
        map = new qq.maps.Map(document.getElementById("tMap"), {
          center: new qq.maps.LatLng(this.lat, this.lng),
          zoom: 14
        });
        marker = new qq.maps.Marker({
          position: new qq.maps.LatLng(this.lat, this.lng),
          map: map,
          draggable: true,
        });
        qq.maps.event.addListener(map, 'click', function (event) {
          this.lat = event.latLng.lat;
          this.lng = event.latLng.lng;
          marker.setPosition(new qq.maps.LatLng(event.latLng.lat, event.latLng.lng))
        });
        geocoder = new qq.maps.Geocoder()
      });
    },
    searchMap() {
      var _this = this;
      console.log(this.inputAddr)
      geocoder.getLocation(this.inputAddr);
      geocoder.setComplete(function (result) {
        _this.lat = result.detail.location.lat;
        _this.lng = result.detail.location.lng;
        map.setCenter(result.detail.location);
        marker.setPosition(result.detail.location)
        qq.maps.event.addListener(marker, 'click', function () {
          console.log("坐标地址为： " + result.detail.location);
        });
      });
      geocoder.setError(function () {
        _this.$message({
          type: 'warning',
          message: '请输入正确的地址'
        })
      });
    },
    TMap() {
      return new Promise(function (resolve, reject) {
        window.init = function () {
          resolve(qq)
        }
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "http://map.qq.com/api/js?v=2.exp&callback=init&key=" + "BJLBZ-FVDRU-XMSV7-BLV52-LHD35-3XFYZ";
        script.onerror = reject;
        document.head.appendChild(script);
      })
    },
    spliceImg(father, index) {
      father.splice(index, 1)
    },
    editIco(item) {
      console.log(item)
      this.usericoNav = item.type;
      var usericos = JSON.parse(JSON.stringify(this.usericos));
      usericos.forEach((val, index) => {
        val.check = false;
        if (item.type == "图标" && item.src == val.icon) {
          val.check = true
        }
      })
      this.usericos = usericos;
      this.usericoImg = item.type == "图片" ? item.src : "";
      this.showSelectIco = true;
    },
    editIcoSuccess: function () { },
    editArticle(action, fn) {
      this.getClassify();
      this.showEditNews = true;
      if (action == 'add') {
        this.forms = {};
        _this.editArticleSuccess = function () {
          console.log(_this.forms)
          var info = { title: _this.forms.label, cover_url: _this.forms.img, cid: _this.forms.classify, content: _this.forms.content };
          addArticle(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showEditNews = false;
          })
        }
      }
      else {
        getArticleOnce({ id: action }, this, res => {
          _this.forms = {
            label: res.data.info.title,
            classify: res.data.info.classify_id,
            content: res.data.info.content,
            img: res.data.info.cover_url,
          }
          _this.editArticleSuccess = function () {
            var info = { id: action, title: _this.forms.label, cover_url: _this.forms.img, cid: _this.forms.classify, content: _this.forms.content };
            editArticle(info, _this, res => {
              _this.$message({
                type: 'success',
                message: res.data.msg
              })
              fn()
              _this.showEditNews = false;
            })
          }

        })
      }
    },
    editArticleSuccess: function () { },
    editSever(action, fn) {
      this.showEditSever = true;
      this.getSeverClassify()
      if (action == 'add') {
        _this.severForm = severForm;
        _this.editSeverSuccess = function () {
          console.log(_this.forms)
          var info = JSON.parse(JSON.stringify(_this.severForm));
          info.cover_url = info.cover_url.join(',');
          info.limited = info.limited == 0 ? 0 : info.limited_num;
          console.log(info.cover_url)
          addSever(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showEditSever = false;
          })
        }
      }
      else {
        action = JSON.parse(JSON.stringify(action));
        if (action.cover_url) {
          action.cover_url = action.cover_url.split(',');
        }
        action.limited_num = action.limited;
        action.limited = action.limited > 0 ? "1" : "0";
        console.log(action)
        _this.severForm = action;
        _this.editSeverSuccess = function () {
          var info = JSON.parse(JSON.stringify(_this.severForm));
          info.limited = info.limited == 0 ? 0 : info.limited_num;
          info.cover_url = info.cover_url.join(',');
          editSever(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showEditSever = false;
          })
        }
      }
    },
    editSeverSuccess: function () { },
    editGoods(action, fn) {
      console.log(action)
      this.showGoods = true;
      this.getClassifyList()
      if (action == 'add') {
        this.classcascader = []
        _this.$set(_this, 'goodsForms', {
          title: '',
          images: [],
          introduction: '',
          cid: '',
          order_by: '',
          price: '',
          promotional_price: '',
          stock: '',
          virtual: '',
          details: '',
          g_options: [],
          table: [
          ]
        })
        _this.editGoodsSuccess = () => {
          var info = JSON.parse(JSON.stringify(_this.goodsForms));
          if (info.images.length > 0) {
            info.images = info.images.join(',')
          }
          info.attr_name = [];
          info.g_options.forEach(val => {
            info.attr_name.push(val.g_o_title)
          })
          if (info.attr_name.length > 0) {
            info.attr_name = info.attr_name.join('|')
          }
          info.cid = _this.classcascader.join(",");
          info.cid = info.cid.split("c")[0];
          addGoods(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showGoods = false;
          })
        }
      }
      else {
        action = JSON.parse(JSON.stringify(action));
        action.sever_7dback = action.sever_7dback == 1;
        action.sever_in24 = action.sever_in24 == 1;
        action.sever_in72 = action.sever_in72 == 1;
        action.sever_ins = action.sever_ins == 1;
        action.sever_quality = action.sever_quality == 1;
        action.cid = action.cid.split(",");
        if (action.cid[0] == action.cid[1]) {
          action.cid[1] += "c"
        }
        _this.classcascader = action.cid;
        if (action.images && typeof (action.images) == 'string') {
          action.images = action.images.split(',');
        }
        action.g_options = [];
        if (action.attr_name) {
          let g_o_title = action.attr_name.split('|');
          g_o_title.forEach((v0, i0) => {
            let arr = [];
            action.table.forEach((v1, i1) => {
              let attr = v1.attr_key.split('|')[i0];
              let hasd = arr.findIndex((v2, i2) => {
                return v2 == attr
              })
              if (hasd == -1) {
                arr.push(attr)
              }
            })
            action.g_options.push({ g_o_title: v0, g_o_value: arr });
          })
        }
        watchTable = true;
        _this.goodsForms = action;
        _this.$nextTick(_ => {
          watchTable = false;
        })
        _this.editGoodsSuccess = function () {
          var info = JSON.parse(JSON.stringify(_this.goodsForms));
          if (info.images.length > 0) {
            info.images = info.images.join(',')
          }
          info.attr_name = [];
          info.g_options.forEach(val => {
            info.attr_name.push(val.g_o_title)
          })
          if (info.attr_name.length > 0) {
            info.attr_name = info.attr_name.join('|')
          }
          info.cid = _this.classcascader.join(",");
          info.cid = info.cid.split("c")[0];
          console.log(info)
          editGoods(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showGoods = false;
          })
        }
      }
    },
    editGoodsSuccess: function () { },
    editCard(action, fn) {
      this.showEditCard = true;
      if (action == 'add') {
        _this.$set(_this, "cardForm", {
          name: '',
          telphone: '',
          post: '',
          email: '',
          wechat: '',
          address: '',
          avatar: '',
          introduction: ''
        })
        _this.editCardSuccess = function () {
          console.log(_this.forms)
          var info = JSON.parse(JSON.stringify(_this.cardForm));
          console.log(info)
          addCard(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showEditCard = false;
          })
        }
      }
      else {
        _this.$set(_this, "cardForm", action)
        _this.editCardSuccess = function () {
          var info = JSON.parse(JSON.stringify(_this.cardForm));
          info.id = action.id;
          editCard(info, _this, res => {
            _this.$message({
              type: 'success',
              message: res.data.msg
            })
            fn()
            _this.showEditCard = false;
          })
        }
      }
    },
    editCardSuccess: function () { },
    selectUrl(appPage, slef) {
      this.showSelectUrl = true;
      this.appPage = appPage;
      console.log(slef)
      if (slef.urldetail) {
        this.selectFirst = slef.urldetail.selectFirst;
        if (this.selectFirst == "map://") {
          this.initMap()
          this.inputAddr = slef.urldetail.inputAddr;
          this.lat = slef.urldetail.lat;
          this.lng = slef.urldetail.lng;
        }
        this.selectLast = slef.urldetail.selectLast;
      }
      this.getArticleList()
      this.getSeverList()
      this.getgoodslist()
      this.getClassifyList()
    },
    resetUrl() {
      this.selectLast = "";
      if (this.selectFirst == "map://") {
        this.initMap()
      }
    },
    selectUrlSuccess: function () { },
    getArticleList() {
      var info = { page: 1, pagesize: 1000 }
      getArticleList(info, this, res => {
        this.articleList = res.data.list;
      })
    },
    getSeverList() {
      var info = { page: 1, pagesize: 1000 }
      getSeverList(info, this, res => {
        this.$set(this, 'severList', res.data.list)
      })
    },
    checkSection(item, num, father) {
      if (num == "once") {
        father.forEach((val, index) => {
          this.$set(val, "check", false)
        })
      }
      this.$set(item, 'check', !item.check)
    },
    checkSectionOk(father) {
      var checklist = [];
      father.forEach((val, index) => {
        if (val.check) {
          checklist.push(val)
        }
      })
      console.log(checklist)
    },
    addCover(where, fn) {
      let mult;
      switch (where) {
        case "goods":
          mult = 5 - this.goodsForms.images.length;
          this.$store.commit("select_img", {
            mult,
            success: res => {
              this.goodsForms.images = [...this.goodsForms.images, ...res]
            }
          })
          break;
        case "card":
          this.$store.commit("select_img", {
            mult: 1,
            success: res => {
              this.cardForm.avatar = res[0] ? res[0] : "";
            }
          })
          break;
        case "article":
          this.$store.commit("select_img", {
            mult: 1,
            success: res => {
              this.forms.img = res[0] ? res[0] : "";
              this.$set(this, 'forms', JSON.parse(JSON.stringify(this.forms)))
            }
          })
          break;
        case "ico":
          this.$store.commit("select_img", {
            mult: 1,
            success: res => {
              this.usericoImg = res[0] ? res[0] : "";
            }
          })
          break;

      }
    },
    addSeverCover() {
      let mult = 4 - _this.severForm.cover_url.length;
      this.$store.commit("select_img", {
        mult,
        success: res => {
          this.severForm.cover_url = [...this.severForm.cover_url, ...res]
        }
      })
    },
    selectImg(fn) {
      this.showImgSelect = true;
      this.getImglist()
    },
    closeArticleImg(target) {
      this.forms.img = ''
    },
    selectimgSuccess: function () { },
    getClassify() {
      get_classify_list(this, res => {
        this.classify = res.data.list
      })
    },
    getSeverClassify() {
      get_sever_classify_list(this, res => {
        this.severClassify = res.data.list
      })
    },
    getClassifyList() {
      getClassifyList(this, res => {
        this.express_list = res.data.express
        this.goodsClassify = res.data.list
      })
    },
    addclassify() {
      this.addinput = true;
      setTimeout(() => {
        this.$refs.addinput.focus();
      }, 10)
    },
    addClassifySubmit(type) {
      console.log('提交', this.classValue)
      if (this.ajax) {
        return false
      }
      this.ajax = true;
      this.addinput = false;
      if (type == "sever") {
        add_sever_classify({ title: this.classValue }, this, res => {
          this.getSeverClassify();
          this.classValue = '';
          this.ajax = false;
        })
      }
      if (type == "goods") {
        addGoodsClassify({ title: this.classValue }, this, res => {
          this.getClassifyList();
          this.classValue = '';
          this.ajax = false;
        })
      }
      else {
        add_classify({ title: this.classValue }, this, res => {
          this.getClassify()
          this.classValue = '';
          this.ajax = false;
        })
      }
      setTimeout(() => { this.ajax = false }, 200)
    },
    btnok() {
      console.log(this.forms)
    },
    onEditorReady(editor) { // 准备编辑器

    },
    onEditorBlur() { }, // 失去焦点事件
    onEditorFocus() { }, // 获得焦点事件
    onEditorChange() { }, // 内容改变事件
  }
}
</script>
<style  lang="scss">
.g_table {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #ddd;
  div {
  }
  .g_table_chid {
    flex: 1;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    .g_table_0 {
      width: 100px;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .secbox .g_table_1_f:first-of-type > .g_table_1 {
      border-top: none;
    }
    .secbox
      .g_table_1_f:first-of-type
      > .thrbox
      .g_table_2_f:first-of-type
      > .g_table_2 {
      border-top: none;
    }
    .g_table_price:last-of-type {
      flex: 1;
      justify-content: flex-start;
    }
    .secbox {
      display: flex;
      flex-direction: column;
      .g_table_1_f {
        display: flex;
        flex: 1;
        width: 760px;
        align-items: stretch;
        .g_table_1 {
          align-items: center;
          width: 100px;
          padding: 0 10px;
          justify-content: center;
          border-left: 1px solid #ddd;
          border-top: 1px solid #ddd;
          &:last-child {
            border-bottom: none;
          }
        }
        .g_table_1_title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .thrbox {
          flex: 1;
          .g_table_2_f {
            display: flex;
            .g_table_2 {
              display: flex;
              width: 100px;
              align-items: center;
              justify-content: center;
              border-left: 1px solid #ddd;
              border-top: 1px solid #ddd;
              padding: 0 10px;
            }
          }
        }
      }
    }
  }
}
.g_table_price:last-of-type {
  flex: 1;
  justify-content: flex-start !important;
}
.topbar {
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 10px 0;
}
.editbox {
  min-height: 400px;
  position: relative;
}
.myimg {
}
.selectIcobox {
  display: flex;
  min-height: 300px;
  align-items: stretch;
}
.selectIcobox .left {
  display: flex;
  width: 140px;
  flex-direction: column;
  border-right: 1px solid #e3e2e8;
}
.selectIcobox .left .li {
  border-bottom: 1px solid #e3e2e8 !important;
  height: 60px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-right: 6px solid transparent;
}
.selectIcobox .imgbox {
  padding: 10px;
  flex: 1;
}
.selectIcobox .imgbox .icosss {
  width: 60px;
  height: 60px;
  background: #ccc;
  border-radius: 4px;
  overflow: hidden;
}
.selectIcobox .imgbox .selimg {
  padding: 0 10px;
  height: 60px;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
}
.selectIcobox .icobox {
  min-height: 200px;
  display: flex;
}
.selectIcobox .icobox .li {
  width: 50px;
  height: 50px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ccc;
  margin: 10px;
  transition: all 0.1s;
  border: 1px solid #fff;
  border-radius: 4px;
}
.selectIcobox .icobox .on {
  border: 1px solid #5874d8;
}
.selectIcobox .icobox .li .ico {
  width: 30px;
  height: 30px;
}
.mbtns {
  margin-top: 20px;
  display: flex;
}
.mbtns1 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.secrchMap {
  padding: 10px 0;
}
.addGoodsDialog {
  .addimg {
    display: flex;
    flex-wrap: wrap;
  }
  .addbtn {
    display: flex;
    flex-direction: column;
    .el-button {
      width: 80px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }
    span {
      height: 30px;
      line-height: 30px;
      margin: 0;
    }
  }
  .goodlist {
    display: flex;
    .imgform {
      margin-top: 0;
      margin-bottom: 10px;
    }
  }
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #44b549 !important;
}
.guige {
  width: 100%;
  padding: 10px;
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  .ggline {
    &:hover .icoclose {
      display: flex !important;
    }
    position: relative;
    margin: 0;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    width: 100%;
    .option_title {
      padding: 10px;
      background-color: #f8f8f8;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icoclose {
        cursor: pointer;
        width: 16px;
        height: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        border-radius: 50%;
        display: none;
        &:hover {
          background: #ccc;
          color: #fff;
        }
      }
    }
    .option_value {
      padding: 10px;
      display: flex;
      flex-wrap: wrap;
      .el-input {
        margin-bottom: 10px;
      }
    }
  }
}
.classifyimg {
  width: 80px;
  height: 80px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
    min-height: 80px;
  }
  &:hover .clearImgTr {
    opacity: 1;
  }
  .clearImgTr {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    color: #fff;
    opacity: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.4);
    font-size: 20px;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.addclassifyimg {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  border: 1px dashed #aaa;
  transition: all 0.3s;
  &:hover {
    border: 1px dashed #333;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialog.vue